module.exports = __webpack_public_path__ + "static/media/enableFullScreen-light.11524fed.svg";